import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { mediaApi, usersApi } from "api";
import { populateProfile } from "store/actions/users";
import { splitErrors } from "features/account/profile";

// Saves the learner's account (PUT /users) and refreshes the store.
// `save(payload, { avatar })` uploads a new data-URL avatar first.
export default function useSaveProfile() {
  const dispatch = useDispatch();
  const details = useSelector((state) => state.users);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null); // null | "saving" | "saved"

  async function save(payload, { avatar } = {}) {
    setErrors({});
    setStatus("saving");
    try {
      const body = { ...payload };
      if (avatar && avatar.indexOf("base64") > -1) body.avatar = (await mediaApi.upload(avatar)).data.image;
      const res = await usersApi.update(body);
      dispatch(populateProfile({ ...details, ...res.data }));
      setStatus("saved");
      return res.data;
    } catch (error) {
      setErrors(splitErrors(error?.response?.data?.message, "Could not save. Please try again."));
      setStatus(null);
      return null;
    }
  }

  const reset = () => setStatus(null);
  return { details, errors, status, save, reset };
}
